import moment from 'moment'
import { FunctionComponent, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import Alert, { AlertType } from '../../components/atoms/Alert/Alert'
import { AlertWithLink } from '../../components/atoms/Alert/types/alert.types'
import DatepickerBox from '../../components/molecules/DatepickerBox'
import ChartRow from '../../components/organisms/ChartRow/ChartRow'
import DetailsCardSection from '../../components/organisms/DetailsCardSection/DetailsCardSection'
import FilterBar from '../../components/organisms/FilterBar/FilterBar'
import SummaryRow from '../../components/organisms/SummaryRow'
import useConnectRequest from '../../hooks/useConnectRequest'
import { MainState } from '../../redux/reducers'
import { requestActions } from '../../redux/requests/'
import {
  FETCH_ALL_DISCARDED,
  FETCH_ALL_PRODUCT_DATA_BY_USER,
  FETCH_DETAILED_DATA_NEW,
  FETCH_DIESEL_DATA,
  FETCH_DISCARDED,
  FETCH_DISCARDED_WITH_RANGE,
  FETCH_MOVING_AVERAGES,
  FETCH_NET_PRICE_CHART_DATA,
  FETCH_SUMMARY_DATA,
} from '../../redux/requests/products/product.actions'
import { Heading2 } from '../../theme/typography'
import * as S from './styled'

type OwnProps = {
  uid: string
}

type Props = OwnProps

export enum Period {
  LAST,
  MONTH,
  YEAR,
  ALL,
  CUSTOM,
  NEW,
}

export enum Product {
  EGG = 'eggs',
  WHEAT = 'wheat',
  OATS = 'oats',
  RAPESEED = 'raps',
  FODER = 'foder',
  DIESEL = 'diesel',
}

export enum Company {
  ALL = 'ALL',
  KRON = 'KRON',
  DAVA = 'DAVA',
  KGS = 'KGS',
}

function getStartDate(date: Date, unit: Period) {
  return unit === Period.MONTH
    ? moment(date).subtract(1, 'month').toDate()
    : unit === Period.YEAR
    ? moment(date).subtract(1, 'year').toDate()
    : new Date()
}

export const DashBoard: FunctionComponent<Props> = ({ uid }) => {
  const product = useSelector((state: MainState) => state.misc.product)
  const user = useSelector((state: MainState) => state.misc.user)
  const dispatch = useDispatch()
  let [showCalender, setShowCalender] = useState(false)
  const isLifeWeek = useSelector((state: MainState) => state.misc.lifeWeek)
  const {
    data: productData,
    loading: loadingProductData,
    error: errorProductData,
  } = useConnectRequest(FETCH_ALL_PRODUCT_DATA_BY_USER)

  const { data: discarded, loading: loadingDiscarded } = useConnectRequest(FETCH_DISCARDED)
  const { data: discardedWithRange, loading: loadingDiscardedWithRange } = useConnectRequest(
    FETCH_DISCARDED_WITH_RANGE,
  )
  console.log({ discarded })

  const {
    data: movingAverages,
    loading: loadingAvg,
    error: errorAvg,
  } = useConnectRequest(FETCH_MOVING_AVERAGES)
  const {
    data: dieselData,
    loading: loadingDieselData,
    error: errorDieselData,
  } = useConnectRequest(FETCH_DIESEL_DATA)
  console.log({ dieselData })
  const {
    data: summarySorted,
    loading: loadingSummary,
    error: errorSummary,
  } = useConnectRequest(FETCH_SUMMARY_DATA)

  const {
    data: netPriceChartData,
    loading: loadingNetPriceChartData,
    error: errorNetPriceChartData,
  } = useConnectRequest(FETCH_NET_PRICE_CHART_DATA)

  const { data: detailedDataDates, loading: loadingDetDates } =
    useConnectRequest(FETCH_DETAILED_DATA_NEW)

  const { data: allDiscarded, loading: loadingAllDiscarded } =
    useConnectRequest(FETCH_ALL_DISCARDED)

  const [startDate, setStartDate] = useState(getStartDate(new Date(), Period.YEAR))
  const [endDate, setEndDate] = useState(new Date())

  const [packeryFilter, setPackeryFilter] = useState(Company.ALL)
  const [house, setHouse] = useState(0)
  const [weeks, setWeeks] = useState(6)
  const [hasStartedLoading, setHasStartedLoading] = useState(false)
  const [startDateLocal, setStartDateLocal] = useState(new Date())
  const [endDateLocal, setEndDateLocal] = useState(new Date())
  const [error, setError] = useState<AlertWithLink | null>(null)
  const [errorStatus, setErrorStatus] = useState(false)
  useEffect(() => {
    if (!product) {
      if (user && user.defaultProduct) {
        dispatch({ type: 'SET_PRODUCT', product: user.defaultProduct })
      }
    }
  }, [user])

  useEffect(() => {
    dispatch(requestActions.auth.getUserByUid(uid))
  }, [])

  useEffect(
    () => {
      if (product) {
        dispatch(
          requestActions.products.fetchSummaryData(
            uid,
            moment(startDate).format('YYYY-MM-DD'),
            moment(endDate).format('YYYY-MM-DD'),
            packeryFilter,
            house,
            product as Product,
          ),
        )
        dispatch(
          requestActions.products.fetchDiscarded(
            uid,
            moment(startDate).format('YYYY-MM-DD'),
            moment(endDate).format('YYYY-MM-DD'),
            isLifeWeek.discarded,
          ),
        )

        dispatch(
          requestActions.products.fetchDieselData(
            uid,
            moment(startDate).format('YYYY-MM-DD'),
            moment(endDate).format('YYYY-MM-DD'),
          ),
        )
        dispatch(requestActions.products.fetchDiscardedWithRange(uid))

        // dispatch(
        //   requestActions.products.fetchLineChartData(
        //     uid,
        //     moment(startDate).format('YYYY-MM-DD'),
        //     moment(endDate).format('YYYY-MM-DD'),
        //     packeryFilter,
        //     house,
        //     product as Product,
        //     isLifeWeek.netPrice,
        //   ),
        // )
        dispatch(
          requestActions.products.fetchNetPriceChartData(
            uid,
            moment(startDate).format('YYYY-MM-DD'),
            moment(endDate).format('YYYY-MM-DD'),
            packeryFilter,
            house,
            product as Product,
          ),
        )
        if (product === Product.EGG) {
          if (!movingAverages.length || movingAverages.length !== weeks) {
            dispatch(requestActions.products.fetchMovingAverages(weeks, product))
          }
          dispatch(
            requestActions.products.fetchDetailedDataNEW(
              uid,
              moment(startDate).format('YYYY-MM-DD'),
              moment(endDate).format('YYYY-MM-DD'),
              house,
              packeryFilter,
              product,
            ),
          )
        }

        dispatch(requestActions.products.fetchAllProductDataByUser(uid))

        dispatch(requestActions.products.fetchAllDiscarded(uid))

        setTimeout(() => {
          setHasStartedLoading(true)
        }, 1000)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [weeks, endDate, packeryFilter, house, startDate, product, user, isLifeWeek.discarded],
  )

  // if (lineChartData.govStats) {
  //   lineChartData.govStats = lineChartData.govStats.map(item =>
  //     item.indoorPriceKg === 0 ? { ...item, indoorPriceKg: NaN } : item,
  //   )
  // }
  return (
    <>
      {errorStatus && error !== null && (
        <Alert
          type={error.type}
          message={error.message}
          LinkComponent={error.LinkComponent}
          to={error.to}
          lcText={error.lcText}
        />
      )}
      <S.Container>
        <S.FullRow>
          {user && (
            <FilterBar
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              setWeeks={setWeeks}
              showCalender={showCalender}
              setShowCalender={setShowCalender}
              setPackeryFilter={setPackeryFilter}
              productData={productData}
              setHouse={setHouse}
              startDateLocal={startDateLocal}
              endDateLocal={endDateLocal}
              setStartDateLocal={setStartDateLocal}
              setEndDateLocal={setEndDateLocal}
              packeryFilter={packeryFilter}
              house={house}
              product={product ?? ''}
            />
          )}
        </S.FullRow>
        {showCalender && (
          <S.DatePickerBoxWrapper>
            <DatepickerBox
              showCalender={showCalender}
              setShowCalender={setShowCalender}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              startDate={startDate}
              endDate={endDate}
              setWeeks={setWeeks}
              startDateLocal={startDateLocal}
              setStartDateLocal={setStartDateLocal}
              endDateLocal={endDateLocal}
              setEndDateLocal={setEndDateLocal}
            />
          </S.DatePickerBoxWrapper>
        )}

        {summarySorted.length < 1 && !(loadingAvg || loadingSummary || loadingProductData) ? (
          hasStartedLoading &&
          !errorStatus &&
          (() => {
            setError(
              (): AlertWithLink => ({
                type: AlertType.Error,
                message: `Ingen tillgänglig data, möjligtvis ändra produkt, filter eller ladda upp`,
                LinkComponent: Link,
                to: '/documents',
                lcText: 'filen igen',
              }),
            )
            setErrorStatus(true)
            return <></>
          })()
        ) : (
          <>
            {errorStatus && setErrorStatus(() => false)}
            <S.Title>
              <Heading2 left>
                {' '}
                Sammanställning
                {(errorAvg || errorSummary || errorProductData) && ' Something went wrong!'}
              </Heading2>
              <BeatLoader
                //css={override}
                loading={loadingAvg || loadingSummary || loadingProductData}
                size={15}
              />
            </S.Title>
            {summarySorted.length > 0 && (
              <S.SummaryDataWrapper>
                <SummaryRow dashboardData={summarySorted} />
              </S.SummaryDataWrapper>
            )}

            {!loadingNetPriceChartData &&
              !!discarded &&
              !!allDiscarded &&
              !!discardedWithRange &&
              !loadingAllDiscarded &&
              !loadingDiscardedWithRange &&
              !loadingAllDiscarded &&
              !loadingDiscarded &&
              detailedDataDates && (
                <S.LineChartDataWrapper>
                  <ChartRow
                    weeks={weeks}
                    //lineChartData={lineChartData}
                    discarded={discarded}
                    pieChartData={detailedDataDates}
                    allDiscarded={allDiscarded}
                    discardedWithRange={discardedWithRange}
                    netPriceChartData={netPriceChartData}
                  />
                </S.LineChartDataWrapper>
              )}

            {/* {summarySorted.length > 0 && <BarChartRow summarySorted={summarySorted} />} */}

            {product === Product.EGG && (
              <>
                {' '}
                <S.Title>
                  <Heading2 left> Detaljerad information</Heading2>
                </S.Title>
                <S.DetailedCardSectionWrapper>
                  {detailedDataDates[0] && !loadingDetDates && (
                    <DetailsCardSection
                      details={[detailedDataDates[0], ...detailedDataDates.slice(6, 10)]}
                    />
                  )}
                  {detailedDataDates[0] && !loadingDetDates && (
                    <DetailsCardSection details={[...detailedDataDates.slice(1, 6)]} />
                  )}
                </S.DetailedCardSectionWrapper>
              </>
            )}
          </>
        )}
      </S.Container>
    </>
  )
}

export default DashBoard
